import { baseAPIFactory } from "./index.js"

const { transactions } = baseAPIFactory("/datastore/transactions")

export const getSectorTransactions = async (route) => {
    const response = await transactions.get(route)
    return response
}
